<div class="bg-gray-50 dark:bg-gray-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
    
    <mat-form-field class="w-full"  subscriptSizing="dynamic">
        <mat-label>Adres e-mail</mat-label>
        <mat-icon matPrefix [svgIcon]="'tabler_outline:mail'" class="text-gray-400 mr-2"></mat-icon>
        <input type="email" lowercaseEmail matInput [formControl]="loginForm.controls.emailAddress" placeholder="jan.kowalski@firma.pl">
        <mat-error *ngIf="loginForm.controls.emailAddress.touched && loginForm.controls.emailAddress?.errors?.['invalidEmail']">
            Nieprawidłowy format adresu e-mail
        </mat-error>
    </mat-form-field>

    <mat-form-field class="w-full mt-2" subscriptSizing="dynamic">
        <mat-label>Hasło</mat-label>
        <mat-icon matPrefix [svgIcon]="'tabler_outline:lock'" class="text-gray-400 mr-2"></mat-icon>
        <input (keyup.enter)="login()" [type]="showPassword ? 'text' : 'password'" matInput [formControl]="loginForm.controls.password" placeholder="••••••••">
        <button mat-icon-button matSuffix (click)="showPassword = !showPassword" type="button">
            <mat-icon [svgIcon]="showPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
        </button>
        <mat-error *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.['minlength']">
            Hasło musi mieć minimum 8 znaków
        </mat-error>
    </mat-form-field>

    <button mat-flat-button color="primary" [disabled]="isProcessing" class="w-full h-12 text-base mt-4" (click)="login()">
        <mat-icon *ngIf="isProcessing" class="icn-spinner mr-2" [svgIcon]="'tabler_outline:loader'"></mat-icon>
        <span *ngIf="!isProcessing">Zaloguj się</span>
        <span *ngIf="isProcessing">Logowanie...</span>
    </button>
</div>
